/**
 * ARQUIVO ATUALIZADO (VERSÃO FINAL E CORRETA)
 * Caminho: src/firebase/config.js
 * Descrição: A constante 'app' foi adicionada à exportação final para
 * resolver o erro de build, e a região das Functions foi garantida.
 */
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableMultiTabIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import '../services/firestoreInterceptor';

const firebaseConfig = {
  apiKey: "AIzaSyByevFFc9fqgQ4Iu6FTMxbkkj2Gaas_6Ks",
  authDomain: "pro-saude-mental.firebaseapp.com",
  projectId: "pro-saude-mental",
  storageBucket: "pro-saude-mental.firebasestorage.app",
  messagingSenderId: "126792081070",
  appId: "1:126792081070:web:654ac44ec860339866973f"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);

// 🚀 Persistência Multi-Abas no IndexedDB: Evita consumo de leituras no recarregamento ou novas abas
// Salas de teleconsulta (/t, /tele, /teleconsulta) NÃO usam o cache compartilhado entre abas:
// nesse modo só uma "aba líder" recebe atualizações do servidor e repassa às outras. Se a aba
// líder estiver em segundo plano/congelada (muito comum no celular), a sala de espera do paciente
// não fica sabendo da aprovação e trava até recarregar a página.
const isTeleconsultationRoute = typeof window !== 'undefined'
  && /^\/(t|tele|teleconsulta)\//.test(window.location.pathname);

if (typeof window !== 'undefined' && !isTeleconsultationRoute) {
  enableMultiTabIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('⚠️ [Firestore Persistence] Múltiplas abas concorrentes sem suporte a trava compartilhada.');
    } else if (err.code === 'unimplemented') {
      console.warn('⚠️ [Firestore Persistence] Navegador não suporta persistência IndexedDB.');
    }
  });
}

const storage = getStorage(app);
const functions = getFunctions(app, 'southamerica-east1');

//if (window.location.hostname === "localhost") {
//  console.log("Modo de desenvolvimento: Conectando aos emuladores do Firebase...");
//  connectAuthEmulator(auth, "http://localhost:9099");
//  connectFirestoreEmulator(db, "localhost", 8080);
//  connectStorageEmulator(storage, "localhost", 9199);
//  connectFunctionsEmulator(functions, "localhost", 5001);
//}

// <<-- CORREÇÃO APLICADA AQUI -->>
// Adiciona 'app' à lista de constantes exportadas.
export { app, auth, db, storage, functions };